
//nhận vào 1 số VD:1000 trả ra 1,000
//thêm dấu phẩy sau 3 số
export const  numberWithCommas = (x=0) => {

    let y = x || 0;
    return y.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
}
